// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3K9J3","info":"Note_info__3bTX8","note":"Note_note__2yikP","actions":"Note_actions__3u5Gq"};